import ThinDivider from "components/common/ThinDivider";
import React from "react";
import BlockTooltip from "./BlockTooltip";
import Break from "./images/break.svg?react";

export default function NewBlockTooltip({ startDate, endDate, overlappingPlannedBreaks }) {
  return (
    <div>
      <BlockTooltip endDate={endDate} overlappingPlannedBreaks={overlappingPlannedBreaks} startDate={startDate} />
      {overlappingPlannedBreaks.length > 0 && (
        <>
          <ThinDivider />
          <Break />
        </>
      )}
    </div>
  );
}
